var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}.cls-6{fill:#ff4f4f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1038.4,
    cy: 556.7,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(293 1469.2) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1099.6,
    cy: 616.8,
    rx: 17.2,
    ry: 25,
    transform: "translate(15.7 1260.7) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M846.3,1084.7a295.3,295.3,0,0,1-63.3-6.6c-42.4-9.3-74.9-27.3-94-52.2a30,30,0,0,1,47.7-36.4c25.4,33.2,103.9,41.5,161.9,30.2,39.7-7.8,85.8-27.7,99.7-54.7a30,30,0,1,1,53.4,27.3c-20.9,40.8-73.8,73-141.6,86.3A334.7,334.7,0,0,1,846.3,1084.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1203.7,1084.7a334.7,334.7,0,0,1-63.8-6.1c-67.8-13.3-120.7-45.5-141.6-86.3a30,30,0,1,1,53.4-27.3c13.9,27,60,46.9,99.7,54.7,58,11.3,136.5,3,161.9-30.3a30,30,0,0,1,47.7,36.5c-19.1,24.9-51.6,42.9-94,52.2A295.3,295.3,0,0,1,1203.7,1084.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M814.4,1055.4l44.4,266.8c15.5,93.2,87.8,157.9,166.2,157.9h0c78.4,0,150.7-64.7,166.2-157.9l44.8-269.3c-71.9-36.1-159.7-11.3-215.7-63C939.5,1051.3,883,1020.1,814.4,1055.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M643.9,924.3a30,30,0,0,1-19.2-53.1c3-2.5,59.1-48.5,129.4-62.2a116.6,116.6,0,0,0-46.5-22.9c-25.2-6.1-45.6-2.7-45.8-2.6a30,30,0,0,1-11.2-59c3.2-.6,33.2-5.8,71.1,3.3,35.7,8.7,85.4,32.1,119.1,94.9a30,30,0,0,1-31.1,43.8c-70.5-11.1-145.9,50.3-146.7,50.9A30.1,30.1,0,0,1,643.9,924.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1406.1,924.3a30,30,0,0,0,19.2-53.1c-3-2.5-59.1-48.5-129.4-62.2a116.6,116.6,0,0,1,46.5-22.9c25.2-6.1,45.6-2.7,45.8-2.6a30,30,0,0,0,11.2-59c-3.2-.6-33.2-5.8-71.1,3.3-35.7,8.7-85.4,32.1-119.1,94.9a30,30,0,0,0,31.1,43.8c70.5-11.1,145.9,50.3,146.7,50.9A30.1,30.1,0,0,0,1406.1,924.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1202.4,1255c-37.4-78.6-102.9-98.6-177.4-98.6s-140,20-177.4,98.5l11.2,67.3c15.5,93.2,87.8,157.9,166.2,157.9h0c78.4,0,150.7-64.7,166.2-157.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcited);
export default __webpack_public_path__ + "static/media/excited.a755be55a2430d9e56109092c495cd6e.svg";
export { ForwardRef as ReactComponent };